module.exports = __webpack_public_path__ + "static/media/agility-landing.81edb31c.png";